import { ColProps, Form, Select } from "antd";
import { ReactNode } from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface Props<TSchema extends FieldValues> {
  name: Path<TSchema>; // Allow only field names (string) that are listed into the Schema
  label: ReactNode;
  placeholder: string;
  disabled?: boolean;
  errorMessage?: string;
  control: Control<TSchema>;
  options: { value: string; label: string }[];
  labelCol?: ColProps | undefined;
  wrapperCol?: ColProps | undefined;
  isVertical?: boolean;
}

export default function FieldSelect<TSchema extends FieldValues>(
  props: Props<TSchema>,
) {
  const {
    name,
    label,
    errorMessage,
    control,
    options,
    placeholder,
    disabled,
    labelCol,
    wrapperCol,
    isVertical,
  } = props;
  return (
    <Form.Item
      validateStatus={errorMessage ? "error" : ""}
      help={errorMessage || null}
      label={label}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      layout={isVertical ? "vertical" : "horizontal"}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Select
            {...field}
            value={field.value || null}
            placeholder={placeholder}
            options={options}
            disabled={disabled}
          >
            {options.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        )}
      />
    </Form.Item>
  );
}
